import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { akEditorMobileMaxWidth, FULL_PAGE_EDITOR_TOOLBAR_HEIGHT } from '@atlaskit/editor-shared-styles';
export var MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 868;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var mainToolbarIconBeforeStyle = css(_defineProperty({
  margin: "var(--ds-space-200, 16px)",
  height: "var(--ds-space-400, 32px)",
  width: "var(--ds-space-400, 32px)"
}, "@media (max-width: ".concat(akEditorMobileMaxWidth, "px)"), {
  gridColumn: 1,
  gridRow: 1
}));
var mainToolbarFirstChild = css(_defineProperty({
  display: 'flex',
  flexGrow: 1
}, "@media (max-width: ".concat(akEditorMobileMaxWidth, "px)"), {
  gridColumn: 1,
  gridRow: 1
}));
var mainToolbarFirstChildTowLine = function mainToolbarFirstChildTowLine() {
  var editorToolbarHeight = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT();
  return css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
    flex: '1 1 100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: editorToolbarHeight,
    justifyContent: 'flex-end',
    minWidth: 'fit-content'
  }));
};
export var mainToolbarFirstChildStyle = function mainToolbarFirstChildStyle(twoLineEditorToolbar) {
  return [mainToolbarFirstChild, twoLineEditorToolbar && mainToolbarFirstChildTowLine];
};
var mainToolbarSecondChild = css({
  minWidth: 'fit-content'
});
var mainToolbarSecondChildTwoLine = function mainToolbarSecondChildTwoLine() {
  var editorToolbarHeight = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT();
  return css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
    display: 'flex',
    flexGrow: 1,
    flex: '1 1 100%',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: editorToolbarHeight,
    minWidth: 0
  }));
};
export var mainToolbarSecondChildStyle = function mainToolbarSecondChildStyle(twoLineEditorToolbar) {
  return [mainToolbarSecondChild, twoLineEditorToolbar && mainToolbarSecondChildTwoLine];
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var nonCustomToolbarWrapperStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var customToolbarWrapperStyle = css({
  alignItems: 'center',
  display: 'flex'
});